<template>
  <v-app-bar app color="#ffffff" style="border-bottom: 3px solid #c0c0c0" clipped-left flat>
    <span style="font-size: 0.7rem">
      <strong class="text-sm-subtitle-1">
        <b>{{ contactName }}</b>
      </strong>
    </span>
  </v-app-bar>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import Store from '@/store';

@Component
export default class HeaderBar extends Vue {
  get contactName() {
    if (Store.getters.yoyaku.property) {
      return Store.getters.yoyaku.property.contactName;
    }
  }
}
</script>
<style lang="scss"></style>
